/* site/cms/useCmsSettings.js — the published site settings (nav / logo / header / footer) the
 * SiteContent provider fetched from GET /api/site/settings, in the builder's canonical shape
 * (withSettingsDefaults), or null when nothing has been published — the chrome then keeps its
 * built-in prototype nav and footer, byte for byte. */
import { useMemo } from "react";
import { useSiteCmsSettings } from "../content/SiteContent";
import { withSettingsDefaults } from "./builder/store";

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

/** raw settings document → withSettingsDefaults shape, or null when there is nothing published */
export function shapeCmsSettings(raw) {
  if (!isObj(raw)) return null;
  const has = ["nav", "logo", "header", "footer"].some((k) => isObj(raw[k]));
  return has ? withSettingsDefaults(raw) : null;
}

export function useCmsSettings() {
  const raw = useSiteCmsSettings();
  return useMemo(() => shapeCmsSettings(raw), [raw]);
}

export default useCmsSettings;
